import type { JSX } from 'react'
import type { IGridLoadingByCardProps } from '../GridLoadingByCard'

import { TextBoxColors } from 'atoms/TextBox'
import { CardsInRow } from 'containers/RowContainer'
import { GridLoadingByCard } from '../GridLoadingByCard'
import {
  GridLoadingByCardPaddings,
  GridLoadingByCardTitleMargins,
} from '../GridLoadingByCard.h'

export interface IV6GridLoadingByCardProps extends IGridLoadingByCardProps {}

export const V6GridLoadingByCard = ({
  children,
  title = '',
  cardsInRow = CardsInRow.Vertical_6,
  paddings = GridLoadingByCardPaddings.SIZE_10,
  colorTitle = TextBoxColors.TEXT_ICON_PRIMARY,
  marginTitle = GridLoadingByCardTitleMargins.SIZE_10,
  ...rest
}: IV6GridLoadingByCardProps): JSX.Element => (
  <GridLoadingByCard
    title={title}
    cardsInRow={cardsInRow}
    paddings={paddings}
    colorTitle={colorTitle}
    marginTitle={marginTitle}
    {...rest}
  >
    {children}
  </GridLoadingByCard>
)
